import { PRODUCT_TYPES, PRODUCT_TYPES_PER_BRANCH } from './Constants.js'

export const toPascalCase = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const getCalculateDate = (value) => {
  let date1 = new Date(value);
  let date2 = new Date();
  return (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24);
}

export const getPolicyType = (policy) => {
  const branch = getBranchFromPolicy(policy);
  return PRODUCT_TYPES_PER_BRANCH[PRODUCT_TYPES.BUEN_VIAJE].includes(branch) ? PRODUCT_TYPES.BUEN_VIAJE : PRODUCT_TYPES.GENERIC;

}

const getBranchFromPolicy = (poliza) => {
  return poliza.substr(2, 2);
}
